// import React from "react";
// import { useState, useEffect } from "react";
// import moment from "moment";
// // import { UNIVERSAL_SEARCH_URL } from "../../../utils/constants";
// import profilesvg from "./../../assets/profile.svg"
// import userprofile from "./../../assets/user-profile.svg";
// import { Button } from "../../common/Button/Button"
// import CentralizedNotesModal from "../../components/ServiceRequests/Handholder/CentralizedNotesModal";
// import audioIcon from "../../assets/audioIcon.svg"
// import audioIcon2 from "../../assets/audioIcon2.svg"
// import videoIcon from "../../assets/videoIcon.svg"
// import videoIcon2 from "../../assets/videoIcon2.svg"
// import textIcon from "../../assets/textIcon.svg"
// import textIcon2 from "../../assets/textIcon2.svg"
// import viewIconTwo from "../../assets/viewIconTwo.svg"
// import Select from "react-select";
// import Spinner from '../../common/Spinner/Spinner';

// import Modal from "react-modal";
// import ModalContent from '../../common/Modal/ModalContent';
// import close_modal from '../../assets/ic_close_wh.svg'
// import {
//     TextField
// } from '@material-ui/core';
// import api from "../../utils/api";
// import { toast } from "react-toastify";

// export default function UserDetailContainer(props) {
//     // const [educationalQualification, setEducationalQualification] = useState();

//     // useEffect(() => {
//     // 	let eQ;
//     // 	if (
//     // 		props.data &&
//     // 		Object.keys(props.data).length &&
//     // 		props.userData &&
//     // 		Object.keys(props.userData).length
//     // 	) {
//     // 		eQ = props.userData.customer_profile_data.Education.filter(
//     // 			(f) =>
//     // 				String(f.value) ===
//     // 				String(props.data[0]["educational_qualification"])
//     // 		);
//     // 		console.log("AJCBDB", eQ);

//     // 		if (eQ.length > 0) setEducationalQualification(eQ[0].label);
//     // 	}
//     // }, [props.userData, props.data]);

//     const [selectedOption, setSelectedOption] = useState(null)
//     const [isTestimonialAddModalOpen, setIsTestimonialAddModalOpen] = useState(false);
//     const [isTestimonialModalOpen, setIsTestimonialModalOpen] = useState(false);
//     const [iconClickedName, setIconClickedName] = useState(null);

//     const [props?.userTestimonials, setprops?.userTestimonials] = useState(null);
//     const [video, setVideo] = useState("");
//     const [audio, setAudio] = useState("");
//     const [text, setText] = useState("");
//     const [isTestimonialEdit, setIsTestimonialEdit] = useState(false)

//     const [editedTestimonialVal, setEditedTestimonialVal] = useState("");


//     const onTestimonialChange = (option) => {
//         console.log(option, ">>>testimonial change option")
//         if (option) {
//             setSelectedOption(option);
//         } else {
//             setSelectedOption(null);
//         }
//     }

//     // modal open when there is option selected for testimonal add
//     useEffect(() => {
//         if (selectedOption) {
//             setIsTestimonialAddModalOpen(!isTestimonialAddModalOpen);
//         }
//     }, [selectedOption])

//     useEffect(() => {
//         console.log(props.userTestimonials, ">>>>props.userTestimonials in useEffect");

//         setprops?.userTestimonials(props.userTestimonials)
//     }, [props.userTestimonials])

//     const handleTestimonialIconClick = (e) => {
//         setIconClickedName(e.target.name);
//         setIsTestimonialModalOpen(!isTestimonialModalOpen);

//         if (e.target.name == "video") {
//             setEditedTestimonialVal(props?.userTestimonials?.Video)
//         }

//         if (e.target.name == "audio") {
//             setEditedTestimonialVal(props?.userTestimonials?.Audio)
//         }

//         if (e.target.name == "text") {
//             setEditedTestimonialVal(props?.userTestimonials?.Text)
//         }
//     }

//     const handleVideoInputChange = (e) => {
//         const { name, value } = e.target;
//         console.log(name, ">>>>name")
//         console.log(value, ">>>>value");

//         setVideo(value)
//     };

//     const handleAudioInputChange = (e) => {
//         const { name, value } = e.target;
//         console.log(name, ">>>>name")
//         console.log(value, ">>>>value");

//         setAudio(value)
//     };

//     const handleTextInputChange = (e) => {
//         const { name, value } = e.target;
//         console.log(name, ">>>>name")
//         console.log(value, ">>>>value");

//         setText(value)
//     };

//     const uploadVideo = async () => {
//         try {
//             if (props.userDetail && video) {
//                 const { nUserId, sMobile, nEntryId } = props?.userDetail[0];

//                 if (nUserId && sMobile && nEntryId) {
//                     console.log(video, ">>>>>video");
//                     const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Video": video } };
//                     console.log(payload, ">>>>video upload payload");

//                     const res = await api.jpmcThreeSixtyDegreeViewSavePersonaDetails(payload);
//                     console.log(res, ">>>>res on upload video");

//                     if (res) {
//                         toast(String("Video testimonal saved successfully"), {
//                             autoClose: 5000,
//                             type: toast.TYPE.SUCCESS,
//                         });

//                         setVideo(null);
//                         setIsTestimonialAddModalOpen(false)
//                         setSelectedOption(null);
//                     }
//                 }
//             }
//         } catch (err) {
//             toast(String("Video testimonial not saved"), {
//                 autoClose: 5000,
//                 type: toast.TYPE.ERROR,
//             });
//             setVideo(null);
//             setIsTestimonialAddModalOpen(false)
//             setSelectedOption(null);
//         }
//     };

//     const uploadAudio = async () => {
//         try {
//             if (props.userDetail && audio) {
//                 const { nUserId, sMobile, nEntryId } = props?.userDetail[0];

//                 if (nUserId && sMobile && nEntryId) {
//                     console.log(video, ">>>>>video");
//                     const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Audio": audio } };
//                     console.log(payload, ">>>>audio upload payload");

//                     const res = await api.jpmcThreeSixtyDegreeViewSavePersonaDetails(payload);
//                     console.log(res, ">>>>res on upload audio");

//                     if (res) {
//                         toast(String("Audio testimonal saved successfully"), {
//                             autoClose: 5000,
//                             type: toast.TYPE.SUCCESS,
//                         });

//                         setAudio(null);
//                         setIsTestimonialAddModalOpen(false);
//                         setSelectedOption(null);
//                     }
//                 }
//             }
//         } catch (err) {
//             toast(String("Audio testimonial not saved"), {
//                 autoClose: 5000,
//                 type: toast.TYPE.ERROR,
//             });
//             setAudio(null);
//             setIsTestimonialAddModalOpen(false)
//             setSelectedOption(null);
//         }
//     };

//     const uploadText = async () => {
//         try {
//             if (props.userDetail && text) {
//                 const { nUserId, sMobile, nEntryId } = props?.userDetail[0];

//                 if (nUserId && sMobile && nEntryId) {
//                     console.log(text, ">>>>>Text");
//                     const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Text": text } };
//                     console.log(payload, ">>>>text upload payload");

//                     const res = await api.jpmcThreeSixtyDegreeViewSavePersonaDetails(payload);
//                     console.log(res, ">>>>res on upload text");

//                     if (res) {
//                         toast(String("Text testimonal saved successfully"), {
//                             autoClose: 5000,
//                             type: toast.TYPE.SUCCESS,
//                         });

//                         setText(null);
//                         setIsTestimonialAddModalOpen(false);
//                         setSelectedOption(null);
//                     }
//                 }
//             }
//         } catch (err) {
//             toast(String("Text testimonial not saved"), {
//                 autoClose: 5000,
//                 type: toast.TYPE.ERROR,
//             });
//             setText(null);
//             setIsTestimonialAddModalOpen(false)
//             setSelectedOption(null);
//         }
//     };

//     const handleCancelUpload = () => {
//         setVideo(null);
//         setAudio(null);
//         setText(null)
//         setSelectedOption(null);

//         setIsTestimonialAddModalOpen(false);
//     }

//     const handleCancelUploadNew = () => {
//         setVideo(null);
//         setAudio(null);
//         setText(null)
//         setIconClickedName(null);
//         setIsTestimonialModalOpen(false);
//         setEditedTestimonialVal("");
//         setIconClickedName(null);
//         setIsTestimonialEdit(false);
//     }

//     const editTestimonialClicked = () => {
//         setIsTestimonialEdit(true)
//     }

//     const updateTestimonial = async (payload, iconClickedName) => {
//         console.log(iconClickedName, ">>>>>iconClickedName on update testimonial");

//         try {
//             const updateTestimonial = await api.updatePersonaDetail(payload)

//             if (updateTestimonial) {
//                 toast(String(`${iconClickedName} testimonal updated successfully`), {
//                     autoClose: 5000,
//                     type: toast.TYPE.SUCCESS,
//                 });

//                 console.log(payload.sMobile, ">>>>>payload.sMobile try");

//                 props.getUserPersonaDetails(payload.sMobile)
//                 setEditedTestimonialVal("");
//                 setIsTestimonialModalOpen(false);
//                 setIconClickedName(null);
//                 setIsTestimonialEdit(false)
//             }
//         } catch {
//             console.log(payload.sMobile, ">>>>>payload.sMobile catch");
//             toast(String(`${iconClickedName} testimonal not updated`), {
//                 autoClose: 5000,
//                 type: toast.TYPE.ERROR,
//             });
//             setEditedTestimonialVal("");
//             setIsTestimonialModalOpen(false);
//             setIconClickedName(null);
//             setIsTestimonialEdit(false)
//         }
//     }

//     const handleUpdateTestimonial = () => {
//         console.log(iconClickedName, ">>>>iconClickedName");

//         if (iconClickedName == "video") {
//             const { nUserId, sMobile, nEntryId } = props?.userDetail[0];
//             const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Video": editedTestimonialVal } };
//             updateTestimonial(payload, iconClickedName)
//         }

//         if (iconClickedName == "audio") {
//             const { nUserId, sMobile, nEntryId } = props?.userDetail[0];
//             const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Audio": editedTestimonialVal } };
//             updateTestimonial(payload, iconClickedName)
//         }

//         if (iconClickedName == "text") {
//             const { nUserId, sMobile, nEntryId } = props?.userDetail[0];
//             const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Text": editedTestimonialVal } };
//             updateTestimonial(payload, iconClickedName)
//         }
//     }

//     const deleteTestimonialFunction = async (payload, deleteTestimonialType) => {
//         console.log(payload, ">>>>delete testi oayload");

//         try {
//             const deleteTestimonialResponse = await api.jpmcThreeSixtyDegreeViewDeletePersonaDetails(payload)

//             if (deleteTestimonialResponse) {
//                 toast(String(`${deleteTestimonialType} testimonial deleted successully`), {
//                     autoClose: 5000,
//                     type: toast.TYPE.SUCCESS,
//                 });
//                 props.getUserPersonaDetails(payload.sMobile)
//                 setVideo("");
//                 setAudio("");
//                 setText("");
//                 setIconClickedName(null)
//                 setIsTestimonialModalOpen(false);
//             }
//         } catch (err) {
//             toast(String(`${deleteTestimonialType} testimonial not deleted`), {
//                 autoClose: 5000,
//                 type: toast.TYPE.ERROR,
//             });
//             setVideo("");
//             setAudio("");
//             setText("");
//             setIconClickedName(null)
//             setIsTestimonialModalOpen(false);
//         }
//     }
//     const handleDelete = async (deleteTestimonialType) => {
//         console.log(deleteTestimonialType, ">>>deleteTestimonialType");

//         if (deleteTestimonialType == "video") {
//             const { nUserId, sMobile, nEntryId } = props?.userDetail[0];
//             const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Video": props?.userTestimonials?.Video } };
//             deleteTestimonialFunction(payload, deleteTestimonialType)
//         }

//         if (deleteTestimonialType == "audio") {
//             const { nUserId, sMobile, nEntryId } = props?.userDetail[0];
//             const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Audio": props?.userTestimonials?.Audio } };
//             deleteTestimonialFunction(payload, deleteTestimonialType)
//         }

//         if (deleteTestimonialType == "text") {
//             const { nUserId, sMobile, nEntryId } = props?.userDetail[0];
//             const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Text": props?.userTestimonials?.Text } };
//             deleteTestimonialFunction(payload, deleteTestimonialType)
//         }


//         // try {
//         //     const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId };
//         //     const deleteTestimonialResponse = await api.jpmcThreeSixtyDegreeViewDeletePersonaDetails()
//         // } catch (err) {
//         //     toast(String(`${deleteTestimonialType} testimonal not deleted`), {
//         //         autoClose: 5000,
//         //         type: toast.TYPE.ERROR,
//         //     });
//         // }
//     }

//     const addTestimonialFunction = async (payload, testimonialType) => {
//         try {
//             const res = await api.jpmcThreeSixtyDegreeViewSavePersonaDetails(payload);
//             console.log(res, ">>>>res on upload audio");

//             if (res) {
//                 toast(String(`${testimonialType} testimonal saved successfully`), {
//                     autoClose: 5000,
//                     type: toast.TYPE.SUCCESS,
//                 });
//                 props.getUserPersonaDetails(payload.sMobile)
//                 setVideo("");
//                 setAudio("");
//                 setText("");
//                 setIsTestimonialModalOpen(false);
//             }
//         } catch (err) {
//             toast(String(`${testimonialType} not added`), {
//                 autoClose: 5000,
//                 type: toast.TYPE.ERROR,
//             });
//             setVideo("");
//             setAudio("");
//             setText("");
//         }
//     }

//     const handleAddTestimonial = async (testimonialType) => {
//         console.log(testimonialType, ">>>>testimonialType");
//         if (testimonialType == "video" && video) {
//             console.log(video, ">>>>video");
//             const { nUserId, sMobile, nEntryId } = props?.userDetail[0];
//             const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Video": video } };
//             addTestimonialFunction(payload, testimonialType)
//         }

//         if (testimonialType == "audio" && audio) {
//             console.log(audio, ">>>>audio");
//             const { nUserId, sMobile, nEntryId } = props?.userDetail[0];
//             const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Audio": audio } };
//             addTestimonialFunction(payload, testimonialType)
//         }

//         if (testimonialType == "text" && text) {
//             console.log(text, ">>>>text");
//             const { nUserId, sMobile, nEntryId } = props?.userDetail[0];
//             const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Text": text } };
//             addTestimonialFunction(payload, testimonialType)
//         }

//     }

//     console.log(selectedOption, ">>>>>selectedOption");
//     console.log(video, ">>>>selected video");
//     console.log(audio, ">>>>Selected audio");
//     console.log(props.userDetail, ">>>>>props.userDetail");
//     console.log(props?.userTestimonials, ">>>>props?.userTestimonials in userDetailContainer");

//     const renderUserData = () => {
//         console.log("user details props", props.userDetail);

//         let temp = props.userDetail.map((e, index) => {
//             return (
//                 <div key={index}>
//                     <section className={`user-information userinfowidth ${props.isPersonaLoading && "set-opacity"}`}>
//                         {props.isPersonaLoading && <Spinner className="center" />}
//                         <div className="container">
//                             <div className="row">
//                                 <div className="col-md-12">
//                                     <h3 className="heading">User Information</h3>
//                                 </div>
//                             </div>
//                             <div className="row table-row" style={{ width: "100%" }}>
//                                 <div className="col-md-6 col1">
//                                     <div className="inline">
//                                         <h4>User Id:{" "}</h4>
//                                         <p>
//                                             {`${e["nUserId"] ?? ""}`}
//                                         </p>
//                                     </div>

//                                     <div className="inline">
//                                         <h4>Entry Id:{" "}</h4>
//                                         <p>
//                                             {`${e["nEntryId"] ?? ""}`}
//                                         </p>
//                                     </div>

//                                     <div className="inline">
//                                         <h4>Name:</h4>
//                                         <p>{`${e["sFirstName"]} ${e["sLastName"]}`}</p>
//                                     </div>
//                                     {/* <div className="inline">
//                                         <h4>Email ID:</h4>
//                                         <p>{`${e["sEmailAddress"] ?? ""}`}</p>
//                                     </div> */}
//                                     <div className="inline">
//                                         <h4>Contact No:</h4>
//                                         <p>{`${e["sMobile"] ?? ""}`}</p>
//                                     </div>
//                                     <div className="inline">
//                                         <h4>Email:</h4>
//                                         <p>{`${e["sEmailAddress"] ?? ""}`}</p>
//                                     </div>
//                                     <div className="inline">
//                                         <h4>Date of Joining:{" "}</h4>
//                                         <p>
//                                             {moment(e["dtCreated"]).format("DD/MM/YYYY")}
//                                             {/* {`${e["age"]}`} */}
//                                         </p>
//                                     </div>
//                                     <div className="inline">
//                                         <h4>Gender:</h4>
//                                         <p>{`${e["sGender"] ?? ""}`}</p>
//                                     </div>

//                                     <div className="inline">
//                                         <h4>Age:</h4>
//                                         <p>{`${e["age"] ?? ""}`}</p>
//                                     </div>
//                                     {/* <div className="inline" style={{ backgroundColor: "", width: "100%" }}>
//                                         <h4>Add Testimonial:</h4>
//                                         <Select
//                                             options={[
//                                                 { label: "Audio", value: "Audio" },
//                                                 { label: "Video", value: "Video" },
//                                                 { label: "Text", value: "Text" },
//                                             ]}
//                                             onChange={onTestimonialChange}
//                                             value={selectedOption}
//                                             placeholder="Testimonial Type"
//                                             isClearable
//                                             styles={{
//                                                 container: (base) => ({
//                                                     ...base,
//                                                     width: "70%",
//                                                 }),
//                                                 control: (base) => ({
//                                                     ...base,
//                                                     width: "70%",
//                                                 }),
//                                             }}
//                                         />
//                                     </div> */}
//                                 </div>
//                                 <div className="col-md-6 col2">
//                                     <div className="inline">
//                                         <h4>Business Name:</h4>
//                                         <p>{`${e["sBusinessName"] ?? ""}`}</p>
//                                     </div>
//                                     <div className="inline">
//                                         <h4>Business Turnover:{" "}</h4>
//                                         <p>{`${e["sBusinessTurnover"] ?? ""}`}</p>
//                                     </div>
//                                     <div className="inline">
//                                         <h4>Business Pincode:{" "}</h4>
//                                         <p>
//                                             {`${e["sBusinessPincode"] ?? ""}`}
//                                         </p>
//                                     </div>
//                                     <div className="inline">
//                                         <h4>Location:</h4>
//                                         {/* <p>{`${e["country"] ?? ""}`}</p> */}
//                                         <p>{`${e["location"] ?? ""}`}</p>
//                                     </div>
//                                     <div className="inline">
//                                         <h4>Family Income:</h4>
//                                         <p>{`${e["sFamilyIncome"] ?? ""}`}</p>
//                                     </div>
//                                     <div className="inline">
//                                         <h4>Business Started Year:</h4>
//                                         <p>{`${e["sBusinessStartedYear"] ?? ""}`}</p>
//                                     </div>
//                                     <div className="inline">
//                                         <h4>Business Sector:</h4>
//                                         <p>{`${e["sBusinessSector"] ?? ""}`}</p>
//                                     </div>
//                                     <div className="inline">
//                                         <h4>Catologue URL:</h4>
//                                         {/* <p>{`${e[""] ?? ""}`}</p> */}
//                                         <p>
//                                             {e["sCatalogueUrl"] ? (
//                                                 <>
//                                                     <a
//                                                         style={{
//                                                             color: "rgb(118, 40, 124)",
//                                                             textDecoration: "underline",
//                                                             cursor: "pointer",
//                                                             marginLeft: "5px",
//                                                         }}
//                                                         href={e["sCatalogueUrl"]}
//                                                         target="_blank"
//                                                         rel="noopener noreferrer"
//                                                     >
//                                                         yes
//                                                     </a>
//                                                 </>
//                                             ) : (
//                                                 "no"
//                                             )}
//                                         </p>
//                                         {/* <Typography><strong>Catalogue URL:</strong>{<a style={{ color: "rgb(118, 40, 124)", textDecoration: "underline", cursor: "pointer", marginLeft:"5px" }} href={`${user.sCatalogueUrl}`} target="_blank">yes</a> || "no"}</Typography> */}
//                                     </div>
//                                     <div className="inline">
//                                         <h4>User Testimonial:</h4>

//                                         <p>
//                                             <>
//                                                 {/* <span><audioIcon width="40" height="40" fill="#76287c" /></span> */}
//                                                 {
//                                                     props?.userTestimonials?.Video ? (
//                                                         <img onClick={handleTestimonialIconClick} name="video" src={videoIcon} alt="Video Icon" width="30" height="30" style={{ paddingRight: "10px" }} />
//                                                     ) : (
//                                                         <img onClick={handleTestimonialIconClick} name="video" src={videoIcon2} alt="Video Icon" width="30" height="30" style={{ paddingRight: "10px", filter: 'invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(90%) contrast(85%)' }}  />
//                                                     )
//                                                 }

//                                                 {
//                                                     props?.userTestimonials?.Audio ? (
//                                                         <img onClick={handleTestimonialIconClick} name="audio" src={audioIcon} alt="Audio Icon" width="30" height="30" style={{ paddingRight: "10px" }} />
//                                                     ) : (
//                                                         <img onClick={handleTestimonialIconClick} name="audio" src={audioIcon2} alt="Audio Icon" width="30" height="30" style={{ paddingRight: "10px", filter: 'invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(90%) contrast(85%)' }} />
//                                                     )
//                                                 }

//                                                 {
//                                                     props?.userTestimonials?.Text ? (
//                                                         <img onClick={handleTestimonialIconClick} name="text" src={textIcon} alt="Text Icon" width="30" height="30" style={{ paddingRight: "10px" }} />
//                                                     ) : (
//                                                         <img onClick={handleTestimonialIconClick} name="text" src={textIcon2} alt="Text Icon" width="30" height="30" style={{ paddingRight: "10px", filter: 'invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(90%) contrast(85%)' }} />
//                                                     )
//                                                 }
//                                                 {/* <img onClick={handleTestimonialIconClick} src={videoIcon} alt="Video Icon" width="28" height="58" /> */}
//                                                 {/* <img onClick={handleTestimonialIconClick} src={audioIcon} alt="Audio Icon" width="32" height="32" /> */}
//                                                 {/* <img onClick={handleTestimonialIconClick} src={textIconTwo} alt="Text Icon" width="58" height="58" /> */}
//                                                 {/* <img src={viewIconTwo} alt="View Icon" width="30" height="30" /> */}
//                                             </>
//                                         </p>
//                                         {/* <Typography><strong>Catalogue URL:</strong>{<a style={{ color: "rgb(118, 40, 124)", textDecoration: "underline", cursor: "pointer", marginLeft:"5px" }} href={`${user.sCatalogueUrl}`} target="_blank">yes</a> || "no"}</Typography> */}
//                                     </div>
//                                 </div>

//                                 {/* <div className="col-md-4 col3" style={{ backgroundColor: "", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
//                                     <div className="inner-col" style={{ backgroundColor: "" }}>
//                                         <div className="" style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
//                                             <img
//                                                 src={userprofile}
//                                                 // width="auto"
//                                                 width="100px"
//                                                 style={{ marginLeft: "4%", cursor: "pointer" }}
//                                                 onClick={() => { props.openUserDetailModal(e["Id"]) }}
//                                             />
//                                             <h6 className="conv-mt10">User Profile</h6>
//                                         </div>
//                                     </div>
//                                 </div> */}
//                             </div>
//                         </div>
//                     </section>
//                 </div>

//                 // ""

//             );
//         });
//         return (
//             <div>
//                 <div>
//                     <span>
//                         <b>{props.label}</b>
//                     </span>
//                 </div>

//                 {temp}
//             </div>
//         );
//     };


//     return props.userDetail ? (
//         <>

//             {renderUserData()}

//             {/* modal for opening the add testimonal, now commented */}
//             {/* <Modal isOpen={isTestimonialAddModalOpen}>
//                 <ModalContent className="dreambig-device-vehicle-filter-modal">
//                     <div className="modal-header" style={{
//                         // backgroundColor: '#76287C',
//                         color: '#fff'
//                     }}>
//                         <span className="modal-title">Add Testimonials</span>
//                         <img
//                             alt="close"
//                             id="Close"
//                             src={close_modal}
//                             className="close modal-close"
//                             // onClick={()=>handleCloseSmsModel(false)}
//                             onClick={() => setIsTestimonialAddModalOpen(false)}
//                         />
//                     </div>

//                     <div className="modal-body">
//                         <div>
//                             <div className='mt-0 mb-3 p-2' style={{ backgroundColor: "" }}>
//                                 {
//                                     <div className="" style={{
//                                         height: "300px",
//                                         backgroundColor: "",
//                                     }}>
//                                         <div className="row" style={{ padding: "0px 30px", backgroundColor: "" }}>
//                                             {
//                                                 selectedOption?.value == "Video" && (
//                                                     <div style={{ marginBottom: '20px', width: '100%' }}>
//                                                         <TextField
//                                                             name="Select Video Testimonial"
//                                                             label="Select Video Testimonial"
//                                                             value={video}
//                                                             onChange={handleVideoInputChange}
//                                                             fullWidth
//                                                             margin="normal"
//                                                         />
//                                                     </div>
//                                                 )

//                                             }

//                                             {
//                                                 selectedOption?.value == "Audio" && (
//                                                     <div style={{ width: '100%' }}>
//                                                         <TextField
//                                                             name="Select Audio Testimonial"
//                                                             label="Select Audio Testimonial"
//                                                             value={audio}
//                                                             onChange={handleAudioInputChange}
//                                                             fullWidth
//                                                             margin="normal"
//                                                         />
//                                                     </div>
//                                                 )
//                                             }

//                                             {
//                                                 selectedOption?.value == "Text" && (
//                                                     <div style={{ width: '100%' }}>
//                                                         <TextField
//                                                             name="Add Text Testimonial"
//                                                             label="Add Text Testimonial"
//                                                             value={text}
//                                                             onChange={handleTextInputChange}
//                                                             fullWidth
//                                                             margin="normal"
//                                                         />
//                                                     </div>
//                                                 )
//                                             }
//                                         </div>

//                                         <div className="row" style={{ padding: "0px 30px", backgroundColor: "" }}>
//                                             <div className="col-12 mt-3 spled-container mt-6" style={{ backgroundColor: "", display: "flex", justifyContent: "flex-end", gap: "20px" }}>
//                                                 <Button onClick={handleCancelUpload}>Cancel</Button>

//                                                 {
//                                                     selectedOption?.value == "Video" && <Button onClick={uploadVideo}>Upload Video</Button>
//                                                 }
//                                                 {
//                                                     selectedOption?.value == "Audio" && <Button onClick={uploadAudio}>Upload Audio</Button>
//                                                 }

//                                                 {
//                                                     selectedOption?.value == "Text" && <Button onClick={uploadText}>Upload Text</Button>
//                                                 }
//                                             </div>
//                                         </div>
//                                     </div>
//                                 }
//                             </div>
//                         </div>
//                     </div>
//                 </ModalContent>
//             </Modal> */}

//             {/* Modal open to add, edit or play testimonial when clicked any of icon */}
//             <Modal isOpen={isTestimonialModalOpen}>
//                 <ModalContent className="dreambig-device-vehicle-filter-modal">
//                     <div className="modal-header" style={{
//                         // backgroundColor: '#76287C',
//                         color: '#fff'
//                     }}>
//                         <span className="modal-title">Add Testimonials</span>
//                         <img
//                             alt="close"
//                             id="Close"
//                             src={close_modal}
//                             className="close modal-close"
//                             // onClick={()=>handleCloseSmsModel(false)}
//                             onClick={handleCancelUploadNew}
//                         />
//                     </div>

//                     <div className="modal-body">
//                         <div>
//                             {/* {loadingInModal && <Spinner className="center" />} */}
//                             <div className='mt-0 mb-3 p-2' style={{ backgroundColor: "" }}>
//                                 {
//                                     <div className="" style={{
//                                         height: "300px",
//                                         backgroundColor: "",
//                                     }}>
//                                         <div className="row" style={{ padding: "0px 30px", backgroundColor: "" }}>
//                                             {
//                                                 <div style={{ marginBottom: '20px', width: '100%' }}>
//                                                     {
//                                                         props?.userTestimonials?.Video ? (
//                                                             iconClickedName == "video" && <TextField
//                                                                 name="Video Testimonial"
//                                                                 label="Video Testimonial"
//                                                                 value={isTestimonialEdit ? editedTestimonialVal : props?.userTestimonials?.Video}
//                                                                 onChange={(e) => setEditedTestimonialVal(e.target.value)}
//                                                                 fullWidth
//                                                                 margin="normal"
//                                                                 disabled={isTestimonialEdit ? false : true}
//                                                             />
//                                                         ) : (
//                                                             iconClickedName == "video" && <TextField
//                                                                 name="Add Video Testimonial"
//                                                                 label="Add Video Testimonial"
//                                                                 value={video}
//                                                                 onChange={(e) => setVideo(e.target.value)}
//                                                                 fullWidth
//                                                                 margin="normal"
//                                                             />
//                                                         )
//                                                     }

//                                                     {
//                                                         props?.userTestimonials?.Audio ? (
//                                                             iconClickedName == "audio" && <TextField
//                                                                 name="Audio Testimonial"
//                                                                 label="Audio Testimonial"
//                                                                 value={isTestimonialEdit ? editedTestimonialVal : props?.userTestimonials?.Audio}
//                                                                 onChange={(e) => setEditedTestimonialVal(e.target.value)}
//                                                                 fullWidth
//                                                                 margin="normal"
//                                                                 disabled={isTestimonialEdit ? false : true}
//                                                             />
//                                                         ) : (
//                                                             iconClickedName == "audio" && <TextField
//                                                                 name="Add Audio Testimonial"
//                                                                 label="Add Audio Testimonial"
//                                                                 value={audio}
//                                                                 onChange={(e) => setAudio(e.target.value)}
//                                                                 fullWidth
//                                                                 margin="normal"
//                                                             />
//                                                         )
//                                                     }

//                                                     {
//                                                         props?.userTestimonials?.Text ? (
//                                                             iconClickedName == "text" && <TextField
//                                                                 name="Text Testimonial"
//                                                                 label="Text Testimonial"
//                                                                 value={isTestimonialEdit ? editedTestimonialVal : props?.userTestimonials?.Text}
//                                                                 onChange={(e) => setEditedTestimonialVal(e.target.value)}
//                                                                 fullWidth
//                                                                 margin="normal"
//                                                                 disabled={isTestimonialEdit ? false : true}
//                                                             />
//                                                         ) : (
//                                                             iconClickedName == "text" && <TextField
//                                                                 name="Add Text Testimonial"
//                                                                 label="Add Text Testimonial"
//                                                                 value={text}
//                                                                 onChange={(e) => setText(e.target.value)}
//                                                                 fullWidth
//                                                                 margin="normal"
//                                                             />
//                                                         )
//                                                     }
//                                                 </div>
//                                             }
//                                         </div>

//                                         <div className="row" style={{ padding: "0px 30px", backgroundColor: "" }}>
//                                             <div className="col-12 mt-3 spled-container mt-6" style={{ backgroundColor: "", display: "flex", justifyContent: "flex-end", gap: "20px" }}>

//                                                 {/* if testimonial exist- edit, open,cancel and if not only add and cancel */}
//                                                 {
//                                                     iconClickedName == "video" && (
//                                                         props?.userTestimonials.Video ?
//                                                             <>
//                                                                 {
//                                                                     isTestimonialEdit ?
//                                                                         <Button onClick={handleUpdateTestimonial}>Update</Button>
//                                                                         :
//                                                                         <Button onClick={editTestimonialClicked}>Edit</Button>
//                                                                 }

//                                                                 <Button>
//                                                                     <a href={props?.userTestimonials?.Video} target="_blank" style={{ textDecoration: "none", color: "#fff" }}>Open</a>
//                                                                 </Button>

//                                                                 <Button onClick={() => handleDelete("video")}>Delete</Button>
//                                                             </>
//                                                             :
//                                                             <Button onClick={() => handleAddTestimonial("video")}>Add</Button>
//                                                     )
//                                                 }

//                                                 {
//                                                     iconClickedName == "audio" && (
//                                                         props?.userTestimonials.Audio ?
//                                                             <>
//                                                                 {
//                                                                     isTestimonialEdit ?
//                                                                         <Button onClick={handleUpdateTestimonial}>Update</Button>
//                                                                         :
//                                                                         <Button onClick={editTestimonialClicked}>Edit</Button>
//                                                                 }

//                                                                 <Button>
//                                                                     <a href={props?.userTestimonials?.Audio} target="_blank" style={{ textDecoration: "none", color: "#fff" }}>Open</a>
//                                                                 </Button>

//                                                                 <Button onClick={() => handleDelete("audio")}>Delete</Button>
//                                                             </>
//                                                             :
//                                                             <Button onClick={() => handleAddTestimonial("audio")}>Add</Button>
//                                                     )
//                                                 }

//                                                 {
//                                                     iconClickedName == "text" && (
//                                                         props?.userTestimonials.Text ?
//                                                             <>
//                                                                 {
//                                                                     isTestimonialEdit ?
//                                                                         <Button onClick={handleUpdateTestimonial}>Update</Button>
//                                                                         :
//                                                                         <Button onClick={editTestimonialClicked}>Edit</Button>
//                                                                 }

//                                                                 <Button>
//                                                                     <a href={props?.userTestimonials?.Text} target="_blank" style={{ textDecoration: "none", color: "#fff" }}>Open</a>
//                                                                 </Button>

//                                                                 <Button onClick={() => handleDelete("text")}>Delete</Button>
//                                                             </>
//                                                             :
//                                                             <Button onClick={() => handleAddTestimonial("text")}>Add</Button>
//                                                     )
//                                                 }

//                                                 {/* <Button onClick={handleCancelUpload}>Add</Button> */}
//                                                 {/* <Button onClick={handleCancelUpload}>Edit</Button> */}
//                                                 {/* <Button onClick={handleCancelUpload}>Open</Button> */}

//                                                 <Button onClick={handleCancelUploadNew}>Cancel</Button>

//                                                 {/* {
//                                                     selectedOption?.value == "Video" && <Button onClick={uploadVideo}>Upload Video</Button>
//                                                 }
//                                                 {
//                                                     selectedOption?.value == "Audio" && <Button onClick={uploadAudio}>Upload Audio</Button>
//                                                 }

//                                                 {
//                                                     selectedOption?.value == "Text" && <Button onClick={uploadText}>Upload Text</Button>
//                                                 } */}
//                                             </div>
//                                         </div>
//                                     </div>
//                                 }
//                             </div>
//                         </div>
//                     </div>
//                 </ModalContent>
//             </Modal>
//         </>
//     ) : (
//         <div>
//             <span>
//                 <b>{props.label}</b>
//                 <br></br>
//                 <a href="https://webapp.deasra.in/LeadUniversalSearch" target="_blank" style={{ marginLeft: "" }}>
//                     <span className="lpm-cons-btns-bordered-filter" style={{ fontSize: "15px" }}>Go to universal search</span>
//                 </a>
//                 <br></br>
//                 <span style={{ marginLeft: "1.5%", fontWeight: "bold" }}>No data found</span>
//             </span>
//         </div>


//     );
// }




////////////////////////////////////////////////////////////////////////
/////////// Updated code with Updated Add/Update/Delete Testimonials ///
////////////////////////////////////////////////////////////////////////
import React from "react";
import { useState, useEffect, useCallback } from "react";
import moment from "moment";
// import { UNIVERSAL_SEARCH_URL } from "../../../utils/constants";
import profilesvg from "./../../assets/profile.svg"
import userprofile from "./../../assets/user-profile.svg";
import { Button } from "../../common/Button/Button"
import CentralizedNotesModal from "../../components/ServiceRequests/Handholder/CentralizedNotesModal";
import audioIcon from "../../assets/audioIcon.svg"
import audioIcon2 from "../../assets/audioIcon2.svg"
import videoIcon from "../../assets/videoIcon.svg"
import videoIcon2 from "../../assets/videoIcon2.svg"
import textIcon from "../../assets/textIcon.svg"
import textIcon2 from "../../assets/textIcon2.svg"
import viewIconTwo from "../../assets/viewIconTwo.svg"
import Select from "react-select";
import Spinner from '../../common/Spinner/Spinner';

import Modal from "react-modal";
import ModalContent from '../../common/Modal/ModalContent';
import close_modal from '../../assets/ic_close_wh.svg'
import {
    TextField
} from '@material-ui/core';
import api from "../../utils/api";
import { toast } from "react-toastify";
import WysiwygTextEditor from './WysiwygTextEditor';
import { DOWNLOAD_API_URL } from '../../utils/constants';

// import for wysiwyg
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import TestimonialDeleteConfirmationModel from './TestimonialDeleteConfirmationModel';
import PlayTestimonial from './PlayTestimonial';


export default function UserDetailContainer(props) {
    const [isTestimonialModalOpen, setIsTestimonialModalOpen] = useState(false);
    const [iconClickedName, setIconClickedName] = useState(null);


    const [editedTestimonialVal, setEditedTestimonialVal] = useState("");
    const [editedTextTestimonialDetail, setEditedTextTestimonialTextDetail] = useState("");
    const [isTestimonialEdit, setIsTestimonialEdit] = useState(false)

    const [video, setVideo] = useState("");
    const [audio, setAudio] = useState("");
    const [text, setText] = useState("");
    const [textDetail, setTextDetail] = useState("");
    const [isTestimonialModalLoading, setIsTestimonialModalLoading] = useState(false)

    // state and function used for wysiwyg
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [editedEditorState, setEditedEditorState] = useState(EditorState.createEmpty());
    const onEditorStateChange = (newEditorState) => {
        if (isTestimonialEdit) {
            setEditedEditorState(newEditorState);
        }

        if (!isTestimonialEdit) {
            setEditorState(newEditorState);
        }
    };

    const [videoFile, setVideoFile] = useState(null);
    const [audioFile, setAudioFile] = useState(null);

    const handleVideoChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type.startsWith("video/")) {
            setVideoFile(file);
        } else {
            alert("Please select a valid video file.");
        }
    };

    const handleAudioChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type.startsWith("audio/")) {
            setAudioFile(file);
        } else {
            alert("Please select a valid video file.");
        }
    };

    const editTestimonialClicked = useCallback(() => {
        console.log(">>>edit tetimonial clicked");
        setIsTestimonialEdit(true)
    }, [isTestimonialEdit])

    // Edit Video
    const handleEditTestimonialVideo = async (testimonialType) => {
        console.log(">>>>handleEditTestimonialVideo update clicked");
        console.log(videoFile, ">>>>selected videoFIle to update");


        if (testimonialType == "video" && videoFile) {
            console.log(videoFile, ">>>>videoFile");

            if (!videoFile) {
                alert("Please select a video first.");
                return;
            }

            const { nUserId, sMobile, nEntryId } = props?.addedTestimonials;

            const formData = new FormData();
            formData.append("nUserId", nUserId);
            formData.append("sMobile", sMobile);
            formData.append("Type", "Testimonials");
            formData.append("subType", "Testimonials");
            formData.append("nResourceInstanceId", nEntryId);
            formData.append("Video", videoFile); // File key matches backend field

            // logging the form data
            const debugPayload = {};
            formData.forEach((value, key) => {
                debugPayload[key] = value;
            });

            console.log(">>>>>>FormData Debug:", debugPayload);
            await editTestimonialFunctionVideo(formData, "video");
        }

        if (testimonialType == "audio" && audioFile) {
            console.log(audioFile, ">>>>audioFile");

            if (!audioFile) {
                alert("Please select a video first.");
                return;
            }

            const { nUserId, sMobile, nEntryId } = props?.addedTestimonials;

            const formData = new FormData();
            formData.append("nUserId", nUserId);
            formData.append("sMobile", sMobile);
            formData.append("Type", "Testimonials");
            formData.append("subType", "Testimonials");
            formData.append("nResourceInstanceId", nEntryId);
            formData.append("Audio", audioFile); // File key matches backend field

            // logging the form data
            const debugPayload = {};
            formData.forEach((value, key) => {
                debugPayload[key] = value;
            });

            console.log(">>>>>>FormData Debug:", debugPayload);
            await editTestimonialFunctionVideo(formData, "audio");
        }
    };


    const editTestimonialFunctionVideo = async (formData, testimonialType) => {
        try {
            setIsTestimonialModalLoading(true);

            const res = await api.jpmcThreeSixtyDegreeViewEditPersonaDetailsVideo(formData);

            if (res) {
                toast(`${testimonialType} testimonial updated successfully`, {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });

                let userMobile = props?.userDetail[0]["sMobile"]
                props?.getUserTestimonial(userMobile);
            }
        } catch (err) {
            toast(`${testimonialType} not added`, {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        } finally {
            setIsTestimonialModalLoading(false);
            setVideoFile(null);
            setAudioFile(null);
            // setIconClickedName(null);
            setIsTestimonialModalOpen(false);
            setIsTestimonialEdit(false);
        }
    };

    const handleUpdateTestimonial = () => {
        console.log(iconClickedName, ">>>>iconClickedName");

        // if (iconClickedName == "text") {
        //     const { nUserId, sMobile, nEntryId } = props?.addedTestimonials;

        //     const convertedWysiwygToJson = saveContent(editedEditorState);

        //     const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Text": editedTestimonialVal, "TextDetail": convertedWysiwygToJson } };
        //     updateTestimonial(payload, iconClickedName)
        // }


        if (iconClickedName == "text") {
            if (editedTestimonialVal || editedEditorState) {
                const { nUserId, sMobile, nEntryId } = props?.addedTestimonials;

                if (editedTestimonialVal && editedEditorState) {
                    const convertedWysiwygToJson = saveContent(editedEditorState);

                    const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Text": editedTestimonialVal, "TextDetail": convertedWysiwygToJson } };
                    updateTestimonial(payload, iconClickedName)
                } else if (editedTestimonialVal && !editedEditorState) {
                    const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Text": editedTestimonialVal, "TextDetail": "" } };
                    updateTestimonial(payload, iconClickedName)
                }else if(editedEditorState && !editedTestimonialVal){
                    const convertedWysiwygToJson = saveContent(editedEditorState);

                    const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Text": "", "TextDetail": convertedWysiwygToJson } };
                    updateTestimonial(payload, iconClickedName)
                }
            }
        }
    }

    // Update testimonial
    const updateTestimonial = async (payload, iconClickedName) => {
        console.log(iconClickedName, ">>>>>iconClickedName on update testimonial");

        try {
            setIsTestimonialModalLoading(true)
            const updateTestimonial = await api.updatePersonaDetail(payload)

            if (updateTestimonial) {
                toast(String(`${iconClickedName} testimonal updated successfully`), {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });

                console.log(payload.sMobile, ">>>>>payload.sMobile try");

                setEditedTestimonialVal("");
                setEditedTextTestimonialTextDetail("");
                setEditedEditorState("")
                setIsTestimonialModalOpen(false);
                setIconClickedName(null);
                setIsTestimonialEdit(false);
                setIsTestimonialModalLoading(false);
                setText("");
                setEditorState("");
                setEditedEditorState("")

                let userMobile = props?.userDetail[0]["sMobile"]
                props?.getUserTestimonial(userMobile);
            }
        } catch {
            console.log(payload.sMobile, ">>>>>payload.sMobile catch");
            toast(String(`${iconClickedName} testimonal not updated`), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            setEditedTestimonialVal("");
            setEditedTextTestimonialTextDetail("");
            setEditedEditorState("")
            setIsTestimonialModalOpen(false);
            setIconClickedName(null);
            setIsTestimonialEdit(false);
            setIsTestimonialModalLoading(false);
            setText("");
            setEditorState("");
            setEditedEditorState("")
        }
    }


    // Add Video
    const handleAddTestimonialVideo = async (testimonialType) => {
        if (testimonialType == "video" && videoFile) {
            console.log(videoFile, ">>>>videoFile");

            if (!videoFile) {
                alert("Please select a video first.");
                return;
            }

            const { nUserId, sMobile, nEntryId } = props?.addedTestimonials;

            const formData = new FormData();
            formData.append("nUserId", nUserId);
            formData.append("sMobile", sMobile);
            formData.append("Type", "Testimonials");
            formData.append("subType", "Testimonials");
            formData.append("nResourceInstanceId", nEntryId);
            formData.append("Video", videoFile); // File key matches backend field

            // logging the form data
            const debugPayload = {};
            formData.forEach((value, key) => {
                debugPayload[key] = value;
            });

            console.log(">>>>>>FormData Debug:", debugPayload);
            await addTestimonialFunctionVideo(formData, "video");
        }

        if (testimonialType == "audio" && audioFile) {
            console.log(audioFile, ">>>>audioFile");

            if (!audioFile) {
                alert("Please select a video first.");
                return;
            }

            const { nUserId, sMobile, nEntryId } = props?.addedTestimonials;

            const formData = new FormData();
            formData.append("nUserId", nUserId);
            formData.append("sMobile", sMobile);
            formData.append("Type", "Testimonials");
            formData.append("subType", "Testimonials");
            formData.append("nResourceInstanceId", nEntryId);
            formData.append("Audio", audioFile); // File key matches backend field

            // logging the form data
            const debugPayload = {};
            formData.forEach((value, key) => {
                debugPayload[key] = value;
            });

            console.log(">>>>>>FormData Debug:", debugPayload);
            await addTestimonialFunctionVideo(formData, "audio");
        }
    };


    const addTestimonialFunctionVideo = async (formData, testimonialType) => {
        try {
            setIsTestimonialModalLoading(true);

            const res = await api.jpmcThreeSixtyDegreeViewSavePersonaDetailsVideo(formData);

            if (res) {
                toast(`${testimonialType} testimonial saved successfully`, {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });
                setVideoFile(null);
                setIsTestimonialModalOpen(false);

                let userMobile = props?.userDetail[0]["sMobile"]
                props?.getUserTestimonial(userMobile);
            }
        } catch (err) {
            toast(`${testimonialType} not added`, {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        } finally {
            setIsTestimonialModalLoading(false);
        }
    };

    // Delete Testimonials
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [deleteToggleModal, setDleteToggleModal] = useState(false);
    const [deleteApprove, setDeleteApprove] = useState(false);


    const openDeleteModel = () => {
        setIsDeleteModalOpen(true)
    }

    const toggleApproveModel = () => {
        setIsDeleteModalOpen(!isDeleteModalOpen)
    }

    const handleDeleteVideo = async (deleteTestimonialType) => {
        console.log(deleteTestimonialType, ">>>deleteTestimonialType");
        toggleApproveModel();

        if (deleteTestimonialType == "video") {
            const { nUserId, sMobile, nEntryId } = props?.addedTestimonials;
            const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Video": props?.addedTestimonials?.Video } };
            deleteTestimonialFunctionVideo(payload, deleteTestimonialType)
        }

        if (deleteTestimonialType == "audio") {
            const { nUserId, sMobile, nEntryId } = props?.addedTestimonials;
            const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Audio": props?.addedTestimonials?.Audio } };
            deleteTestimonialFunctionVideo(payload, deleteTestimonialType)
        }
    }

    const deleteTestimonialFunctionVideo = async (payload, deleteTestimonialType) => {
        console.log(payload, ">>>>delete testi oayload");

        try {
            setIsTestimonialModalLoading(true)
            const deleteTestimonialResponse = await api.jpmcThreeSixtyDegreeViewDeletePersonaDetailsVideo(payload)

            if (deleteTestimonialResponse) {
                toast(String(`${deleteTestimonialType} testimonial deleted successully`), {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });
                // setVideo("");
                // setAudio("");
                // setText("");
                setAudioFile(null);
                setVideoFile(null);
                setIconClickedName(null);
                setIsTestimonialModalOpen(false);
                setIsTestimonialModalLoading(false);

                // setIsDeleteModalOpen(false)

                let userMobile = props?.userDetail[0]["sMobile"]
                props?.getUserTestimonial(userMobile);
            }
        } catch (err) {
            toast(String(`${deleteTestimonialType} testimonial not deleted`), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            // setVideo("");
            // setAudio("");
            // setText("");
            setAudioFile(null);
            setVideoFile(null);
            setIconClickedName(null);
            setIsTestimonialModalOpen(false);
            setIsTestimonialModalLoading(false);
            // setIsDeleteModalOpen(false)
        }
    }

    const handleDelete = async (deleteTestimonialType) => {
        console.log(deleteTestimonialType, ">>>deleteTestimonialType");

        if (deleteTestimonialType == "text") {
            toggleApproveModel()
            const { nUserId, sMobile, nEntryId } = props?.addedTestimonials;

            // const convertedWysiwygToJson = saveContent();

            const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Text": props?.addedTestimonials?.Text, "TextDetail": props?.addedTestimonials?.TextDetail } };
            deleteTestimonialFunction(payload, deleteTestimonialType);
        }
    }

    const deleteTestimonialFunction = async (payload, deleteTestimonialType) => {
        console.log(payload, ">>>>delete testi oayload");

        try {
            setIsTestimonialModalLoading(true)
            setIsDeleteModalOpen(false);
            const deleteTestimonialResponse = await api.jpmcThreeSixtyDegreeViewDeletePersonaDetails(payload)

            if (deleteTestimonialResponse) {
                toast(String(`${deleteTestimonialType} testimonial deleted successully`), {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });
                setVideo("");
                setAudio("");
                setText("");
                setIconClickedName(null)
                setIsTestimonialModalOpen(false);
                setIsTestimonialModalLoading(false);

                let userMobile = props?.userDetail[0]["sMobile"]
                props?.getUserTestimonial(userMobile);

            }
        } catch (err) {
            setIsDeleteModalOpen(false);
            toast(String(`${deleteTestimonialType} testimonial not deleted`), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            setVideo("");
            setAudio("");
            setText("");
            setIconClickedName(null)
            setIsTestimonialModalOpen(false);
        }
    }

    // add text testimonial
    const addTestimonialFunction = async (payload, testimonialType) => {
        try {
            setIsTestimonialModalLoading(true)
            const res = await api.jpmcThreeSixtyDegreeViewSavePersonaDetails(payload);
            console.log(res, ">>>>res on upload audio");

            if (res) {
                toast(String(`${testimonialType} testimonal saved successfully`), {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });
                setVideo("");
                setAudio("");
                setText("");
                setIsTestimonialModalOpen(false);
                setIsTestimonialModalLoading(false)
                setEditorState("");
                setEditedEditorState("")

                let userMobile = props?.userDetail[0]["sMobile"]
                props?.getUserTestimonial(userMobile);
            }
        } catch (err) {
            toast(String(`${testimonialType} not added`), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            setVideo("");
            setAudio("");
            setText("");
            setIsTestimonialModalLoading(false)
            setEditorState("");
            setEditedEditorState("")
        }
    }

    const handleAddTestimonial = async (testimonialType) => {
        console.log(testimonialType, ">>>>testimonialType");
        // if (testimonialType == "video" && video) {
        //     console.log(video, ">>>>video");
        //     const { nUserId, sMobile, nEntryId } = addedTestimonials;
        //     const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Video": video } };
        //     addTestimonialFunction(payload, testimonialType)
        // }

        // if (testimonialType == "audio" && audio) {
        //     console.log(audio, ">>>>audio");
        //     const { nUserId, sMobile, nEntryId } = addedTestimonials;
        //     const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Audio": audio } };
        //     addTestimonialFunction(payload, testimonialType)
        // }


        // if (testimonialType == "text" && (text || textDetail)) {
        //     console.log(text, ">>>>text");
        //     const { nUserId, sMobile, nEntryId } = props?.addedTestimonials;

        //     const convertedWysiwygToJson = saveContent(editorState);

        //     const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Text": text, "TextDetail": convertedWysiwygToJson } };
        //     addTestimonialFunction(payload, testimonialType);
        // }

        if (testimonialType == "text") {

            if (text || editorState) {
                console.log(text, ">>>>text");
                const { nUserId, sMobile, nEntryId } = props?.addedTestimonials;

                if (text && editorState) {
                    const convertedWysiwygToJson = saveContent(editorState);

                    const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Text": text, "TextDetail": convertedWysiwygToJson } };
                    addTestimonialFunction(payload, testimonialType);
                } else if (text && !editorState) {
                    const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Text": text, "TextDetail": "" } };
                    addTestimonialFunction(payload, testimonialType);
                }else if(editorState && !text){
                     const convertedWysiwygToJson = saveContent(editorState);

                    const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Text": "", "TextDetail": convertedWysiwygToJson } };
                    addTestimonialFunction(payload, testimonialType);
                }
            }

        }

    }

    // Play testimonial in modal
    const [isPlayModalOpen, setIsPlayModalOpen] = useState(false);

    const openPlayModal = () => {
        setIsPlayModalOpen(!isPlayModalOpen);
    }

    // Save content as raw JSON (simulate DB save)
    const saveContent = (unformatedText) => {
        const contentState = unformatedText?.getCurrentContent();
        const raw = convertToRaw(contentState);
        const json = JSON.stringify(raw);

        return json;
    };

    // Load content from raw JSON (simulate DB fetch)
    const loadContent = (editorSavedContent) => {
        if (editorSavedContent) {
            const contentState = convertFromRaw(JSON.parse(editorSavedContent));
            const loadedEditorState = EditorState.createWithContent(contentState);
            return loadedEditorState;
        }
    };

    const handleTestimonialIconClick = (e) => {
        setIsTestimonialModalLoading(false)
        console.log(e, ">>>>e on icon click")
        setIconClickedName(e.target.name);
        setIsTestimonialModalOpen(!isTestimonialModalOpen);

        const iconName = e.target.name;
        const value = iconName === "video" ? props?.addedTestimonials?.Video : iconName === "audio" ? props?.addedTestimonials?.Audio : props?.addedTestimonials?.Text;
        const textDetailVal = iconName === "text" ? props?.addedTestimonials?.TextDetail : "";
        console.log(value, ">>>Value on icon click function called");

        let formattedData = loadContent(textDetailVal);


        // Set the state first
        setIconClickedName(iconName);
        setEditedTestimonialVal(value || "");
        setEditedTextTestimonialTextDetail(textDetailVal);
        setEditedEditorState(formattedData);
        setIsTestimonialModalOpen(true)
    }

    const firstLetterCase = (text) => {
        console.log(text);

        if (text) {
            let splitString = text?.split("");
            console.log(splitString, ">>>>splitString");

            let firstLetter = splitString[0].toUpperCase();
            console.log(firstLetter, ">>>>firstLetter");

            let remainingLetter = splitString.slice(1).join("");
            console.log(remainingLetter, ">>>>remainingLetter");


            return firstLetter + remainingLetter
        }
    }

    const handleCancelUploadNew = useCallback(() => {
        setVideo(null);
        setAudio(null);
        setText(null)
        setIconClickedName(null);
        setIsTestimonialModalOpen(false);
        setEditedTestimonialVal("");
        setIsTestimonialEdit(false);
        setEditorState("");
        setEditedEditorState("")
    }, [video, audio, text, iconClickedName, isTestimonialModalOpen, editedTestimonialVal, isTestimonialEdit])

    const renderUserData = () => {
        console.log("user details props", props.userDetail);

        let temp = props.userDetail.map((e, index) => {
            return (
                <div key={index}>
                    <section className={`user-information userinfowidth ${props.isPersonaLoading && "set-opacity"}`}>
                        {props.isPersonaLoading && <Spinner className="center" />}
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <h3 className="heading">User Information</h3>
                                </div>
                            </div>
                            <div className="row table-row" style={{ width: "100%" }}>
                                <div className="col-md-6 col1">
                                    <div className="inline">
                                        <h4>User Id:{" "}</h4>
                                        <p>
                                            {`${e["nUserId"] ?? ""}`}
                                        </p>
                                    </div>

                                    <div className="inline">
                                        <h4>Entry Id:{" "}</h4>
                                        <p>
                                            {`${e["nEntryId"] ?? ""}`}
                                        </p>
                                    </div>

                                    <div className="inline">
                                        <h4>Name:</h4>
                                        <p>{`${e["sFirstName"]} ${e["sLastName"]}`}</p>
                                    </div>
                                    {/* <div className="inline">
                                        <h4>Email ID:</h4>
                                        <p>{`${e["sEmailAddress"] ?? ""}`}</p>
                                    </div> */}
                                    <div className="inline">
                                        <h4>Contact No:</h4>
                                        <p>{`${e["sMobile"] ?? ""}`}</p>
                                    </div>
                                    <div className="inline">
                                        <h4>Email:</h4>
                                        <p>{`${e["sEmailAddress"] ?? ""}`}</p>
                                    </div>
                                    <div className="inline">
                                        <h4>Date of Joining:{" "}</h4>
                                        <p>
                                            {moment(e["dtCreated"]).format("DD/MM/YYYY")}
                                            {/* {`${e["age"]}`} */}
                                        </p>
                                    </div>
                                    <div className="inline">
                                        <h4>Gender:</h4>
                                        <p>{`${e["sGender"] ?? ""}`}</p>
                                    </div>

                                    <div className="inline">
                                        <h4>Age:</h4>
                                        <p>{`${e["age"] ?? ""}`}</p>
                                    </div>
                                    {/* <div className="inline" style={{ backgroundColor: "", width: "100%" }}>
                                        <h4>Add Testimonial:</h4>
                                        <Select
                                            options={[
                                                { label: "Audio", value: "Audio" },
                                                { label: "Video", value: "Video" },
                                                { label: "Text", value: "Text" },
                                            ]}
                                            onChange={onTestimonialChange}
                                            value={selectedOption}
                                            placeholder="Testimonial Type"
                                            isClearable
                                            styles={{
                                                container: (base) => ({
                                                    ...base,
                                                    width: "70%",
                                                }),
                                                control: (base) => ({
                                                    ...base,
                                                    width: "70%",
                                                }),
                                            }}
                                        />
                                    </div> */}
                                </div>
                                <div className="col-md-6 col2">
                                    <div className="inline">
                                        <h4>Business Name:</h4>
                                        <p>{`${e["sBusinessName"] ?? ""}`}</p>
                                    </div>
                                    <div className="inline">
                                        <h4>Business Turnover:{" "}</h4>
                                        <p>{`${e["sBusinessTurnover"] ?? ""}`}</p>
                                    </div>
                                    <div className="inline">
                                        <h4>Business Pincode:{" "}</h4>
                                        <p>
                                            {`${e["sBusinessPincode"] ?? ""}`}
                                        </p>
                                    </div>
                                    <div className="inline">
                                        <h4>Location:</h4>
                                        {/* <p>{`${e["country"] ?? ""}`}</p> */}
                                        <p>{`${e["location"] ?? ""}`}</p>
                                    </div>
                                    <div className="inline">
                                        <h4>Family Income:</h4>
                                        <p>{`${e["sFamilyIncome"] ?? ""}`}</p>
                                    </div>
                                    <div className="inline">
                                        <h4>Business Started Year:</h4>
                                        <p>{`${e["sBusinessStartedYear"] ?? ""}`}</p>
                                    </div>
                                    <div className="inline">
                                        <h4>Business Sector:</h4>
                                        <p>{`${e["sBusinessSector"] ?? ""}`}</p>
                                    </div>
                                    <div className="inline">
                                        <h4>Catologue URL:</h4>
                                        {/* <p>{`${e[""] ?? ""}`}</p> */}
                                        <p>
                                            {e["sCatalogueUrl"] ? (
                                                <>
                                                    <a
                                                        style={{
                                                            color: "rgb(118, 40, 124)",
                                                            textDecoration: "underline",
                                                            cursor: "pointer",
                                                            marginLeft: "5px",
                                                        }}
                                                        href={e["sCatalogueUrl"]}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        yes
                                                    </a>
                                                </>
                                            ) : (
                                                "no"
                                            )}
                                        </p>
                                        {/* <Typography><strong>Catalogue URL:</strong>{<a style={{ color: "rgb(118, 40, 124)", textDecoration: "underline", cursor: "pointer", marginLeft:"5px" }} href={`${user.sCatalogueUrl}`} target="_blank">yes</a> || "no"}</Typography> */}
                                    </div>
                                    <div className="inline">
                                        <h4>User Testimonial:</h4>

                                        <p>
                                            <>
                                                {/* <span><audioIcon width="40" height="40" fill="#76287c" /></span> */}
                                                {
                                                    props?.addedTestimonials?.Video ? (
                                                        <img onClick={handleTestimonialIconClick} name="video" src={videoIcon} alt="Video Icon" width="30" height="30" style={{ paddingRight: "10px" }} />
                                                    ) : (
                                                        <img onClick={handleTestimonialIconClick} name="video" src={videoIcon2} alt="Video Icon" width="30" height="30" style={{ paddingRight: "10px", filter: 'invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(90%) contrast(85%)' }} />
                                                    )
                                                }

                                                {
                                                    props?.addedTestimonials?.Audio ? (
                                                        <img onClick={handleTestimonialIconClick} name="audio" src={audioIcon} alt="Audio Icon" width="30" height="30" style={{ paddingRight: "10px" }} />
                                                    ) : (
                                                        <img onClick={handleTestimonialIconClick} name="audio" src={audioIcon2} alt="Audio Icon" width="30" height="30" style={{ paddingRight: "10px", filter: 'invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(90%) contrast(85%)' }} />
                                                    )
                                                }

                                                {
                                                    props?.addedTestimonials?.Text || props?.addedTestimonials?.TextDetail ? (
                                                        <img onClick={handleTestimonialIconClick} name="text" src={textIcon} alt="Text Icon" width="30" height="30" style={{ paddingRight: "10px" }} />
                                                    ) : (
                                                        <img onClick={handleTestimonialIconClick} name="text" src={textIcon2} alt="Text Icon" width="30" height="30" style={{ paddingRight: "10px", filter: 'invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(90%) contrast(85%)' }} />
                                                    )
                                                }
                                                {/* <img onClick={handleTestimonialIconClick} src={videoIcon} alt="Video Icon" width="28" height="58" /> */}
                                                {/* <img onClick={handleTestimonialIconClick} src={audioIcon} alt="Audio Icon" width="32" height="32" /> */}
                                                {/* <img onClick={handleTestimonialIconClick} src={textIconTwo} alt="Text Icon" width="58" height="58" /> */}
                                                {/* <img src={viewIconTwo} alt="View Icon" width="30" height="30" /> */}
                                            </>
                                        </p>
                                        {/* <Typography><strong>Catalogue URL:</strong>{<a style={{ color: "rgb(118, 40, 124)", textDecoration: "underline", cursor: "pointer", marginLeft:"5px" }} href={`${user.sCatalogueUrl}`} target="_blank">yes</a> || "no"}</Typography> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                // ""

            );
        });
        return (
            <div>
                <div>
                    <span>
                        <b>{props.label}</b>
                    </span>
                </div>

                {temp}
            </div>
        );
    };

    console.log(props?.addedTestimonials, ">>>>>addedTestimonialsin userDetail container");

    return props.userDetail ? (
        <>

            {renderUserData()}

            {/* Modal open to add, edit or play testimonial when clicked any of icon */}
            {isTestimonialModalOpen && (
                <Modal isOpen={true}>
                    <ModalContent className="jpmc-testimonials-modal">
                        <div className="modal-header" style={{
                            // backgroundColor: '#76287C',
                            color: '#fff'
                        }}>
                            <span className="modal-title">{`${firstLetterCase(iconClickedName)} Testimonial`}</span>
                            <img
                                alt="close"
                                id="Close"
                                src={close_modal}
                                className="close modal-close"
                                // onClick={()=>handleCloseSmsModel(false)}
                                onClick={handleCancelUploadNew}
                            />
                        </div>

                        <div className={`modal-body ${isTestimonialModalLoading && "set-opacity"}`}  style={{ backgroundColor: "" }}>
                            {isTestimonialModalLoading && <Spinner className="center" />}
                            <div style={{ height: "100%" }}>
                                {/* {loadingInModal && <Spinner className="center" />} */}
                                <div className='mt-0 mb-3 p-2' style={{ backgroundColor: "", height: "100%" }}>
                                    {
                                        <div className="" style={{
                                            // height: "300px",
                                            // height: iconClickedName == "text" ? "600px" : "300px",
                                            height: "100%",
                                            backgroundColor: "",
                                            padding: "3px",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-between"
                                        }}>
                                            <div className="row" style={{ padding: "0px 30px", backgroundColor: "" }}>
                                                {
                                                    <div style={{ marginBottom: '20px', width: '100%', backgroundColor: "" }}>
                                                        {
                                                            props?.addedTestimonials?.Video ? (
                                                                iconClickedName == "video" &&
                                                                (
                                                                    <>
                                                                        {
                                                                            !isTestimonialEdit ? (
                                                                                <TextField
                                                                                    name="Video Testimonial"
                                                                                    label="Video Testimonial"
                                                                                    value={isTestimonialEdit ? editedTestimonialVal : props?.addedTestimonials?.Video || ""}
                                                                                    onChange={(e) => setEditedTestimonialVal(e.target.value)}
                                                                                    fullWidth
                                                                                    margin="normal"
                                                                                    disabled={true}
                                                                                />
                                                                            ) : (
                                                                                <input
                                                                                    type="file"
                                                                                    accept="video/*"
                                                                                    onChange={handleVideoChange}
                                                                                    style={{ marginBottom: "10px" }}
                                                                                    disabled={isTestimonialEdit ? false : true}
                                                                                />
                                                                            )
                                                                        }
                                                                    </>

                                                                )
                                                            ) : (
                                                                iconClickedName == "video" &&
                                                                (
                                                                    <>
                                                                        {/* <TextField
                                                                            name="Add Video Testimonial"
                                                                            label="Add Video Testimonial"
                                                                            value={video ? video : ""}
                                                                            onChange={(e) => setVideo(e.target.value)}
                                                                            fullWidth
                                                                            margin="normal"
                                                                        /> */}

                                                                        {/* <br /> */}

                                                                        <input
                                                                            type="file"
                                                                            accept="video/*"
                                                                            onChange={handleVideoChange}
                                                                            style={{ marginBottom: "10px" }}
                                                                        />
                                                                    </>
                                                                )
                                                            )
                                                        }

                                                        {
                                                            props?.addedTestimonials?.Audio ? (
                                                                iconClickedName == "audio" && (
                                                                    <>
                                                                        {
                                                                            !isTestimonialEdit ? (
                                                                                <TextField
                                                                                    name="Audio Testimonial"
                                                                                    label="Audio Testimonial"
                                                                                    value={isTestimonialEdit ? editedTestimonialVal : props?.addedTestimonials?.Audio}
                                                                                    onChange={(e) => setEditedTestimonialVal(e.target.value)}
                                                                                    fullWidth
                                                                                    margin="normal"
                                                                                    disabled={true}
                                                                                />
                                                                            ) : (
                                                                                <input
                                                                                    type="file"
                                                                                    accept="audio/*"
                                                                                    onChange={handleAudioChange}
                                                                                    style={{ marginBottom: "10px" }}
                                                                                    disabled={isTestimonialEdit ? false : true}
                                                                                />
                                                                            )
                                                                        }

                                                                    </>
                                                                )
                                                            ) : (
                                                                iconClickedName == "audio" && (
                                                                    <>
                                                                        {/* <TextField
                                                                            name="Add Audio Testimonial"
                                                                            label="Add Audio Testimonial"
                                                                            value={audio ? audio : ""}
                                                                            onChange={(e) => setAudio(e.target.value)}
                                                                            fullWidth
                                                                            margin="normal"
                                                                        /> */}

                                                                        {/* <br /> */}

                                                                        <input
                                                                            type="file"
                                                                            accept="audio/*"
                                                                            onChange={handleAudioChange}
                                                                            style={{ marginBottom: "10px" }}
                                                                        />
                                                                    </>
                                                                )




                                                            )
                                                        }

                                                        {
                                                            props?.addedTestimonials?.Text || props?.addedTestimonials?.TextDetail ? (
                                                                iconClickedName == "text" && (
                                                                    <>
                                                                        <WysiwygTextEditor
                                                                            // editorState={editorState}
                                                                            editorState={isTestimonialEdit ? editedEditorState : loadContent(props?.addedTestimonials?.TextDetail)}
                                                                            onEditorStateChange={onEditorStateChange}
                                                                        />

                                                                        <br />

                                                                        {/* <TextField
                                                                            name="Add Text Testimonial"
                                                                            label="Add Text Testimonial"
                                                                            value={isTestimonialEdit ? editedTextTestimonialDetail : props?.addedTestimonials?.TextDetail}
                                                                            onChange={(e) => setEditedTextTestimonialTextDetail(e.target.value)}
                                                                            fullWidth
                                                                            margin="normal"
                                                                            multiline
                                                                            minRows={4}
                                                                            disabled={isTestimonialEdit ? false : true}
                                                                        /> */}

                                                                        <TextField
                                                                            name="Testimonial from Google form"
                                                                            label="Testimonial from Google form"
                                                                            value={isTestimonialEdit ? editedTestimonialVal : props?.addedTestimonials?.Text}
                                                                            onChange={(e) => setEditedTestimonialVal(e.target.value)}
                                                                            fullWidth
                                                                            margin="normal"
                                                                            disabled={isTestimonialEdit ? false : true}
                                                                        />
                                                                    </>
                                                                )
                                                            ) : (
                                                                iconClickedName == "text" && (
                                                                    <>
                                                                        <WysiwygTextEditor
                                                                            editorState={editorState}
                                                                            onEditorStateChange={onEditorStateChange}
                                                                        />

                                                                        <br />

                                                                        {/* <TextField
                                                                            name="Add Text Testimonial"
                                                                            label="Add Text Testimonial"
                                                                            value={textDetail}
                                                                            onChange={(e) => setTextDetail(e.target.value)}
                                                                            fullWidth
                                                                            margin="normal"
                                                                            multiline
                                                                            minRows={4}
                                                                        /> */}

                                                                        <TextField
                                                                            name="Testimonial from Google form"
                                                                            label="Testimonial from Google form"
                                                                            value={text ? text : ""}
                                                                            onChange={(e) => setText(e.target.value)}
                                                                            fullWidth
                                                                            margin="normal"
                                                                        />
                                                                    </>
                                                                )
                                                            )
                                                        }
                                                    </div>
                                                }
                                            </div>

                                            <div className="row" style={{ padding: "0px 30px", backgroundColor: "" }}>
                                                <div className="col-12 mt-3 spled-container mt-6" style={{ backgroundColor: "", display: "flex", justifyContent: "flex-end", gap: "20px" }}>

                                                    {/* if testimonial exist- edit, open,cancel and if not only add and cancel */}
                                                    {
                                                        iconClickedName == "video" && (
                                                            props?.addedTestimonials.Video ?
                                                                <>
                                                                    {
                                                                        props.hasJpmcAddEditPower && (
                                                                            isTestimonialEdit ?
                                                                                <Button onClick={() => handleEditTestimonialVideo("video")} disabled={!videoFile}>Update</Button>
                                                                                :
                                                                                <Button onClick={editTestimonialClicked}>Edit</Button>
                                                                        )

                                                                    }

                                                                    {/* when text */}
                                                                    {/* <Button>
                                                                        <a href={props?.addedTestimonials?.Video} target="_blank" style={{ textDecoration: "none", color: "#fff" }}>Open</a>
                                                                    </Button> */}

                                                                    {/* When media file */}
                                                                    {/* <Button disabled={isTestimonialEdit}>
                                                                        <a disabled={isTestimonialEdit} href={`${DOWNLOAD_API_URL}/static_live/Testimonials/${props?.addedTestimonials?.Video}`} target="_blank" style={{ textDecoration: "none", color: "#fff" }}>Open</a>
                                                                    </Button> */}
                                                                    <Button disabled={isTestimonialEdit} onClick={openPlayModal}>
                                                                        <a disabled={isTestimonialEdit} style={{ textDecoration: "none", color: "#fff" }}>Open</a>
                                                                    </Button>

                                                                    {
                                                                        // props.hasJpmcAddEditPower && <Button disabled={isTestimonialEdit} onClick={() => handleDeleteVideo("video")}>Delete</Button>
                                                                        props.hasJpmcAddEditPower && <Button disabled={isTestimonialEdit} onClick={() => openDeleteModel()}>Delete</Button>
                                                                    }

                                                                </>
                                                                :
                                                                <>
                                                                    {
                                                                        <Button onClick={() => handleAddTestimonialVideo("video")}>Upload</Button>
                                                                    }
                                                                </>

                                                        )
                                                    }

                                                    {
                                                        iconClickedName == "audio" && (
                                                            props?.addedTestimonials.Audio ?
                                                                <>
                                                                    {
                                                                        props.hasJpmcAddEditPower && (
                                                                            isTestimonialEdit ?
                                                                                <Button onClick={() => handleEditTestimonialVideo("audio")}>Update</Button>
                                                                                :
                                                                                <Button onClick={editTestimonialClicked}>Edit</Button>
                                                                        )

                                                                    }

                                                                    {/* when text */}
                                                                    {/* <Button>
                                                                        <a href={props?.addedTestimonials?.Audio} target="_blank" style={{ textDecoration: "none", color: "#fff" }}>Open</a>
                                                                    </Button> */}

                                                                    {/* When media file */}
                                                                    {/* <Button disabled={isTestimonialEdit}>
                                                                        <a disabled={isTestimonialEdit} href={`${DOWNLOAD_API_URL}/static_live/Testimonials/${props?.addedTestimonials?.Audio}`} target="_blank" style={{ textDecoration: "none", color: "#fff" }}>Open</a>
                                                                    </Button> */}
                                                                    <Button disabled={isTestimonialEdit} onClick={openPlayModal}>
                                                                        <a disabled={isTestimonialEdit} style={{ textDecoration: "none", color: "#fff" }}>Open</a>
                                                                    </Button>
                                                                    {
                                                                        props.hasJpmcAddEditPower && <Button disabled={isTestimonialEdit} onClick={() => openDeleteModel()}>Delete</Button>
                                                                    }

                                                                </>
                                                                :
                                                                <>
                                                                    {
                                                                        <Button onClick={() => handleAddTestimonialVideo("audio")}>Upload</Button>
                                                                    }
                                                                </>
                                                        )
                                                    }

                                                    {
                                                        iconClickedName == "text" && (
                                                            props?.addedTestimonials.Text || props?.addedTestimonials.TextDetail ?
                                                                <>
                                                                    {
                                                                        props.hasJpmcAddEditPower && (
                                                                            isTestimonialEdit ?
                                                                                <Button onClick={handleUpdateTestimonial}>Update</Button>
                                                                                :
                                                                                <Button onClick={editTestimonialClicked}>Edit</Button>
                                                                        )

                                                                    }

                                                                    <Button>
                                                                        <a href={props?.addedTestimonials?.Text} target="_blank" style={{ textDecoration: "none", color: "#fff" }}>Open</a>
                                                                    </Button>

                                                                    {
                                                                        props.hasJpmcAddEditPower && <Button disabled={isTestimonialEdit} onClick={() => openDeleteModel()}>Delete</Button>
                                                                    }

                                                                </>
                                                                :
                                                                <>
                                                                    {
                                                                        <Button onClick={() => handleAddTestimonial("text")}>Add</Button>
                                                                    }
                                                                </>

                                                        )
                                                    }
                                                    <Button onClick={handleCancelUploadNew}>Cancel</Button>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div style={{ color: "red" }}>
                                    <small>
                                        <i>
                                            {
                                                isTestimonialEdit && <span><strong>Note: </strong></span>
                                            }
                                            {iconClickedName === "video" && isTestimonialEdit && (
                                                <span>
                                                    Editing a video testimonial is <strong>permanent</strong> and will replace the existing file. The original cannot be recovered.
                                                </span>
                                            )}
                                            {iconClickedName === "audio" && isTestimonialEdit && (
                                                <span>
                                                    Editing an audio testimonial is <strong>permanent</strong> and will overwrite the current recording. This action cannot be undone.
                                                </span>
                                            )}
                                            {iconClickedName === "text" && isTestimonialEdit && (
                                                <span>
                                                    Editing a text testimonial is <strong>permanent</strong> and will replace the existing content. Changes cannot be reversed.
                                                </span>
                                            )}
                                        </i>
                                    </small>

                                </div>
                            </div>
                        </div>
                    </ModalContent>
                </Modal>
            )}

            {/* Delete confirmation model */}
            {
                isDeleteModalOpen && <TestimonialDeleteConfirmationModel
                    isOpen={isDeleteModalOpen}
                    setIsDeleteModalOpen={setIsDeleteModalOpen}
                    toggleModal={toggleApproveModel}
                    // deleteApprove={deleteApprove}
                    // deleteModalLoading={deleteModalLoading}

                    iconClickedName={iconClickedName}
                    handleDelete={handleDelete} // to delete text
                    handleDeleteVideo={handleDeleteVideo} // to delete audio and video
                />
            }

            {/* Play Modal */}
            {
                iconClickedName == "video" && isPlayModalOpen && (
                    <PlayTestimonial
                        isPlayModalOpen={isPlayModalOpen}
                        openPlayModal={openPlayModal}
                        media={{ type: iconClickedName, url: `${DOWNLOAD_API_URL}/static_live/Testimonials/${props?.addedTestimonials?.Video}` }}
                    />
                )
            }

            {
                iconClickedName == "audio" && isPlayModalOpen && (
                    <PlayTestimonial
                        isPlayModalOpen={isPlayModalOpen}
                        openPlayModal={openPlayModal}
                        media={{ type: iconClickedName, url: `${DOWNLOAD_API_URL}/static_live/Testimonials/${props?.addedTestimonials?.Audio}` }}
                    />
                )
            }
        </>
    ) : (
        <div>
            <span>
                <b>{props.label}</b>
                <br></br>
                <a href="https://webapp.deasra.in/LeadUniversalSearch" target="_blank" style={{ marginLeft: "" }}>
                    <span className="lpm-cons-btns-bordered-filter" style={{ fontSize: "15px" }}>Go to universal search</span>
                </a>
                <br></br>
                <span style={{ marginLeft: "1.5%", fontWeight: "bold" }}>No data found</span>
            </span>
        </div>


    );
}
